import { TranslateService } from '@ngx-translate/core';

const SUPPORTED_APP_LANGS = new Set(['en', 'he']);

// Match lang=en|he in search or hash query (HashLocationStrategy uses #/path?lang=he).
// resolveStartupLang / UnauthorizedComponent call this so deep links set the UI language.
export function langFromUrlQuery(): string | null {
  const match = /[?&#]lang=([a-zA-Z-]+)/i.exec(window.location.href || '');
  if (!match) {
    return null;
  }
  const normalized = match[1].trim().toLowerCase();
  return SUPPORTED_APP_LANGS.has(normalized) ? normalized : null;
}

// Resolve startup language: URL ?lang= wins, then saved userLang, else English.
// appInitializerFactory uses this so callers can open the app with a chosen default.
export function resolveStartupLang(): string {
  const fromUrl = langFromUrlQuery();
  if (fromUrl) {
    localStorage.setItem('userLang', fromUrl);
    return fromUrl;
  }
  return localStorage.getItem('userLang') || 'en';
}

// Apply lang + document dir/RTL the same way as the language switcher.
// UnauthorizedComponent also calls this when the login route has ?lang=.
export function applyAppLanguage(translate: TranslateService, lang: string): void {
  translate.setDefaultLang('en');
  translate.use(lang);
  localStorage.setItem('userLang', lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
  localStorage.setItem('direction', document.documentElement.dir);
}
